import { render, staticRenderFns } from "./SolicitacaoRespostaAdicionarFornecedor.vue?vue&type=template&id=01650776"
import script from "./SolicitacaoRespostaAdicionarFornecedor.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaAdicionarFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports